export default __webpack_public_path__ + "static/media/bag-shoe.ec7f2aad.png";